RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ChartTooltip = Marionette.CompositeView.extend({
        className: 'metric-summary',

        template: '#widgetMetricTemplate',

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        serializeData: function () {
            const me = this;

            const data = {
                metric: me.model,
                submetric: _.get(me.model, ['submetric']),
                warnings: {}
            };

            return data;
        }
    });
});
